import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useCartStatusReducer = () => useSelector((state: ApplicationState) => state.cartStatus);
